import { compact } from 'lodash';
export var ProjectGroup;
(function (ProjectGroup) {
    ProjectGroup["Admin"] = "[Project]/Admin";
    ProjectGroup["Developer"] = "[Project]/Developer";
    ProjectGroup["Finance"] = "[Project]/Finance";
    ProjectGroup["Marketing"] = "[Project]/Marketing";
    ProjectGroup["Support"] = "[Project]/Support";
    ProjectGroup["L2Support"] = "[Project]/L2Support";
})(ProjectGroup || (ProjectGroup = {}));
export const AnyProjectUser = Object.values(ProjectGroup);
export const projectUsers = (...projectGroups) => compact([ProjectGroup.Admin, ...projectGroups]);
export function getGroupName(group, projectId) {
    return group.replace('[Project]', projectId || '');
}
/**
 * Returns true if `authRequirement` is satisfied by `authGroups`.
 */
export function isAuthorized(authRequirement, sessionAuth, projectId) {
    if (!authRequirement) {
        return true;
    }
    else if (authRequirement === true) {
        return !!sessionAuth;
    }
    else {
        if (!sessionAuth) {
            return false;
        }
        else {
            const requiredGroups = Array.isArray(authRequirement)
                ? authRequirement
                : [authRequirement];
            return requiredGroups.some((requiredGroup) => sessionAuth.includes(getGroupName(requiredGroup, projectId)));
        }
    }
}
